import React from "react";
import HomePage from "../components/Body/HomePage";
import Education from "../components/Body/Education";
import Skills from "../components/Body/Skills";

const Home = () => {
  return (
    <>
      <HomePage />
      <Education />
      {/* <Skills /> */}
    </>
  );
};

export default Home;
